// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  chatbot_url: "https://04vx3m3x5k.execute-api.eu-west-1.amazonaws.com/default/a5o-agent-guide-lambda",
  chatbot_api_key: "AEn6wbwh6d9MyRMD9TApM2uZUjE8q3Fy4ETJW57e",
  do_services_sb_url: "https://dev.a5o.dev.asdh.aws.renault.com/sb/",
  do_services_url: "https://dev.a5o.dev.asdh.aws.renault.com/api/",
  app_url: "https://dev.a5o.dev.asdh.aws.renault.com",
  piwikId: 15,
  api_key:'3_pn_AT9rzFRikgBTHRvY5w6iQh7DiDj5oA7qj6haJ0J_j47sqIM6NAVprXzshCYum',
  api_key_orgAdmin:'3_pgtd3KG9X8y1-kDkMjN45lUiQ9FwesYYF9d2u7oU-d54Dse_lTeBq1cmJ4rs2cws',
  api_key_orgUser:'3_jGV2dW9juhVVUOu8KHrSKkWnRu4PQ1vMi-GXumWaVvcY5gZzd47kcfmvbKxA3UKD',
  api_key_single:'3_fafky50cbkNqiGt007kYcElPREst3XQ0-23ov95nJhVyfFbM7vtvtDHDdJj5zJvD',
  bucket_name:"dev2-a5o-dev2",
  bucket_public_url: "https://a5o.public.asdh.aws.renault.com/documents/",
  region:"eu-west-1",
  jwe_secret: 'MySecretKey256BitForJWEEncryptionPurposesOnly123456789012345678901234567890'
};
